import {isWithdrawalDraftComplete} from "account/withdrawal/withdrawalSubmission";
import {responseStatus} from "utils/ErrorUtils";
import {SPONSOR_LIMITS} from "./sponsorLimits";

/**
 * Whether an advertising withdrawal may be confirmed: the account declaration's own name rule, inside
 * the name field's bound. Like that rule it says nothing about a send in flight, so the confirm button
 * stays focusable while one runs (kitecorp/transferify-ui#3079).
 */
export function isSponsorWithdrawalDraftComplete(name: string): boolean {
	return isWithdrawalDraftComplete(name) && name.length <= SPONSOR_LIMITS.sponsorName;
}

export type SponsorWithdrawalError = "unavailable" | "reauthenticate" | "invalid" | "failure";

export function sponsorWithdrawalError(error: unknown): SponsorWithdrawalError {
	switch (responseStatus(error)) {
		case 404:
		case 409: return "unavailable";
		case 401: return "reauthenticate";
		case 400: return "invalid";
		default: return "failure";
	}
}
